import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "storybook/internal/components";
import goldIcon from "../../../../assets/images/Gold.svg";
import listblackicon from "../../../../assets/images/list-black.svg";
import platiniumIcon from "../../../../assets/images/Platinium.svg";
import silverIcon from "../../../../assets/images/Silver.svg";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import ViewSummaryPopup from "../../../../components/newMotorPolicy/veiwSummaryPopup/viewSummaryPopup";
import TravelBenefitsModal from "../../../../components/newBniTravelPolicy/modals/travelBenefitsModal";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useMotorForm from "../../../../hooks/useMotorFormData";
import useTravelChangePlanFlow from "../../../../hooks/useTravelChangePlanFlow";
import useTravelFormData from "../../../../hooks/useTravelFormData";
import {
  clearCancellationState,
  getCancellationResponse,
  getQuoteWithRefundError,
  getQuoteWithRefundLoading,
  getQuoteWithRefundResponse,
} from "../../../../redux/features/endorsements/cancellationSlice";
import { PolicyViewResponse } from "../../../../redux/features/motor/getQuoteSlice";
import {
  getPolicyViewLoading,
  policyView,
} from "../../../../redux/features/policyDetailsSlice";
import {
  fetchBniTravelPlanPrices,
  selectTravelPlanPrices,
  selectTravelPlanPricesError,
  selectTravelPlanPricesLoading,
} from "../../../../redux/features/quoteSlice";
import { getClientSource } from "../../../../utils/getClientSource";
import PlanCard from "../../../motorInsurancePages/newMotorPolicy/planPages/planCard";
import SelectNewTravelPlanLayout from "./selectNewTravelPlanLayout";

import { TRAVEL_CHANGE_PLAN_SELECT_PLAN } from "../../../motorInsurancePages/newMotorPolicy/Layouts/BottomStickyBtnLayout";

// Travel plans data aligned with the new travel policy planChoice component (BNI plans)
const TRAVEL_PLANS = [
  {
    id: "schengen",
    code: "SCHENGENB",
    name: "Schengen",
    name_ar: "شنغن",
    imgSrc: silverIcon,
    isRecommended: false,
    weightage: 1,
    features: [
      {
        en: "Essential travel protection for Schengen-area destinations. Covers emergency medical expenses, evacuation, repatriation, and trip cancellation, everything you need to meet visa requirements and travel with confidence.",
        ar: "حماية سفر أساسية لوجهات منطقة شنغن. تشمل مصاريف العلاج الطبي الطارئ، والإخلاء، والترحيل، وإلغاء الرحلة، كل ما تحتاجه لاستيفاء متطلبات التأشيرة والسفر بثقة.",
      },
    ],
  },
  {
    id: "worldwide_ex",
    code: "WLEXB",
    name: "Worldwide",
    name_ar: "جميع دول العالم",
    subtitle: "EXCLUDING USA & CANADA",
    subtitle_ar: "باستثناء الولايات المتحدة الأمريكية وكندا",
    imgSrc: goldIcon,
    isRecommended: true,
    weightage: 2,
    features: [
      {
        en: "Comprehensive global coverage excluding USA & Canada. Includes medical, personal accident, baggage, and legal assistance benefits for worry-free travel worldwide.",
        ar: "تغطية شاملة لجميع دول العالم باستثناء أمريكا وكندا. تشمل المزايا الطبية والحوادث الشخصية والأمتعة والمساعدة القانونية لسفر بلا قلق.",
      },
    ],
  },
  {
    id: "worldwide",
    code: "WLB",
    name: "Worldwide",
    name_ar: "جميع دول العالم",
    imgSrc: platiniumIcon,
    isRecommended: false,
    weightage: 3,
    features: [
      {
        en: "Our highest-tier plan with maximum global protection, including USA & Canada. Full medical, accident, liability, and hijacking coverage for total peace of mind.",
        ar: "خطتنا الأشمل بأعلى مستوى من الحماية العالمية، تشمل أمريكا وكندا. تغطية طبية وحوادث ومسؤولية واختطاف لراحة بال كاملة.",
      },
    ],
  },
];

// Initialize plans without static pricing - prices come from API
const getBaseTravelPlans = () =>
  TRAVEL_PLANS.map((plan) => ({
    ...plan,
    // No static pricing - all prices come from API
    price: null,
    price_ar: null,

    // API pricing values - will be populated from API
    premium: null,
    tax: null,
    totalPremium: null,
    hasValidQuote: false,
    apiDataLoaded: false,
  }));

const SelectNewTravelPlan = () => {
  /* Setting up dispatch to call redux */
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* Setting up variables with appropriate requests to send and response to receive, reading from redux/functions */
  const { policy_id } = useParams();
  const [Channel, setChannel] = useState(getClientSource());
  const [PolicyNumber, setPolicyNumber] = useState(policy_id);

  const polReq = {
    PolicyNumber,
    Channel,
  };

  // Reading param from url, incase refresh to call the policy view again
  const policyViewResponseDetails = useSelector(PolicyViewResponse);
  const isPolicyViewLoading = useSelector(getPolicyViewLoading);

  const getQuoteRefundResponse = useSelector(getQuoteWithRefundResponse);
  const getQuoteRefundLoading = useSelector(getQuoteWithRefundLoading);
  const getQuoteRefundError = useSelector(getQuoteWithRefundError);
  const cancellationResponse = useSelector(getCancellationResponse);

  // Travel plan prices selectors
  const planPrices = useSelector(selectTravelPlanPrices);
  const planPricesLoading = useSelector(selectTravelPlanPricesLoading);
  const planPricesError = useSelector(selectTravelPlanPricesError);

  console.log("Policy number is: ", PolicyNumber);
  console.log("Policy View Response is: ", policyViewResponseDetails);
  console.log(
    "Policy view response plan name from outside: ",
    policyViewResponseDetails?.PolicyHeader?.PlanCode,
  );

  const [selectedPlan, setSelectedPlan] = useState();
  const [viewPlanList, setViewPlanList] = useState(false);
  const [currentPlan, setCurrentPlan] = useState("");
  const [plans, setPlans] = useState([]);
  const [ratesLoaded, setRatesLoaded] = useState(false);
  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [loadingError, setLoadingError] = useState(false);
  const [hasTriggeredInitialLoad, setHasTriggeredInitialLoad] = useState(false);

  /* Functions and Variables that are updated with functions/state */
  const { t } = useTranslation();
  const translate = useLanguageTranslate();

  const { handleNextSubstep } = useTravelChangePlanFlow();
  const { saveTravelDataInRedux } = useTravelFormData(
    TRAVEL_CHANGE_PLAN_SELECT_PLAN,
    setSelectedPlan,
  );

  // Motor form hook to save data for Summary component
  const { saveMotorDataInRedux } = useMotorForm(
    TRAVEL_CHANGE_PLAN_SELECT_PLAN,
    setSelectedPlan,
  );

  /* Use Effects, monitor changes to call on [var] change or one time call */
  useEffect(() => {
    if (PolicyNumber) {
      // Calling API /Policy/View
      if (policyViewResponseDetails == null) {
        // Calling API /policy/view
        dispatch(policyView(polReq));
      } else if (
        policyViewResponseDetails?.PolicyHeader?.PolicyNumber != PolicyNumber
      ) {
        // Calling API /policy/view
        dispatch(policyView(polReq));
      }
    }
  }, [policy_id]);

  useEffect(() => {
    dispatch(clearCancellationState());
  }, []);

  useEffect(() => {
    if (!policyViewResponseDetails?.PolicyHeader) return;

    console.log(
      "Policy view response plan code: ",
      policyViewResponseDetails?.PolicyHeader?.PlanCode,
    );
    console.log(
      "Policy view response plan name: ",
      policyViewResponseDetails?.PolicyHeader?.PlanName,
    );
    console.log(
      "🔍 Full PolicyHeader:",
      policyViewResponseDetails?.PolicyHeader,
    );

    // Set current plan but DON'T auto-select it (motor insurance behavior)
    const currentPlanCode = policyViewResponseDetails?.PolicyHeader?.PlanCode;

    // Only update if currentPlan is changing (avoid resetting selectedPlan unnecessarily)
    if (currentPlan !== currentPlanCode) {
      setCurrentPlan(currentPlanCode);

      // Only reset selected plan when current plan first loads/changes
      setSelectedPlan(null);

      console.log(
        "🎯 Current plan set:",
        currentPlanCode,
        "- user must select a different plan",
      );
    }
  }, [policyViewResponseDetails, currentPlan]);

  // Load base plans and fetch prices from API
  useEffect(() => {
    const basePlans = getBaseTravelPlans();
    setPlans(basePlans);

    // Load travel plan prices when component mounts - ONLY ONCE
    if (policyViewResponseDetails?.PolicyHeader && !hasTriggeredInitialLoad) {
      console.log("🎯 Initial plan prices load triggered");
      setHasTriggeredInitialLoad(true);
      loadTravelPlanPrices();
    }
  }, [policyViewResponseDetails]);

  /* Load travel plan prices from API */
  const loadTravelPlanPrices = async () => {
    if (planPricesLoading) return;

    try {
      console.log("🚀 Loading travel plan prices for change plan...");

      // Get current plans state - use fresh base plans if empty
      const currentPlans = plans.length > 0 ? plans : getBaseTravelPlans();
      console.log(
        "🎯 Using plans for mapping:",
        currentPlans.length,
        currentPlans,
      );

      // Get plan type and dates from policy
      const policyHeader = policyViewResponseDetails?.PolicyHeader;
      const planType = policyHeader?.PlanType || "INDIVIDUAL";
      const fromDateStr = policyHeader?.FromDateStr; // e.g., "28/12/2025"
      const toDateStr = policyHeader?.ToDateStr; // e.g., "29/01/2026"

      // Convert dates to required format
      const formatDateForAPI = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      };

      const apiFormData = {
        departureDate: formatDateForAPI(fromDateStr),
        returnDate: formatDateForAPI(toDateStr),
        planType: planType.toLowerCase(),
        isAnnual: false,
        passengers:
          planType === "FAMILY"
            ? Array.from({ length: 2 }, (_, i) => ({ id: i + 1 }))
            : undefined,
      };

      console.log("🎯 Travel Plan Prices API data:", apiFormData);

      // Call the new travel plan prices endpoint (same as new travel flow)
      const result = await dispatch(
        fetchBniTravelPlanPrices({
          formData: apiFormData,
          options: { timeout: 30000 },
        }),
      ).unwrap();

      console.log("🎯 Travel Plan Prices result:", result);

      const apiResult = result.result;

      if (apiResult && apiResult.success && apiResult.data) {
        console.log("✅ Travel plan prices loaded successfully");

        // Map the API response structure: { Plans: [...] }
        const plansFromAPI = apiResult.data.Plans || [];
        console.log("Plans from API:", plansFromAPI);

        // Create mapping from plan codes to our plan IDs (new travel plan codes)
        const planCodeToId = {
          SCHENGENB: "schengen",
          WLEXB: "worldwide_ex",
          WLB: "worldwide",
        };

        // Update plans with pricing from the API
        let updatedPlans = [];
        let successfulPlans = 0;

        updatedPlans = currentPlans.map((plan) => {
          // Find matching plan data from API response by plan code
          const planData = plansFromAPI.find((p) => {
            const apiPlanId = planCodeToId[p.PlanCode];
            return apiPlanId === plan.id;
          });

          if (
            planData &&
            planData.TotalPremium !== undefined &&
            planData.TotalPremium !== null
          ) {
            const apiTotalPremium = planData.TotalPremium || 0;
            successfulPlans++;

            console.log(`✅ Mapping plan ${plan.id}:`, {
              PlanCode: planData.PlanCode,
              Premium: planData.Premium,
              Tax: planData.Tax,
              TotalPremium: planData.TotalPremium,
            });

            return {
              ...plan,
              // Use API pricing
              price: `BHD ${apiTotalPremium.toFixed(3)}`,
              price_ar: `${apiTotalPremium.toFixed(3)} د.ب`,

              // Use API data for calculations - ensure proper structure for TravelSummaryModal
              premium: planData.Premium || apiTotalPremium * 0.909, // Calculate base premium (total - 10% VAT)
              tax: planData.Tax || apiTotalPremium * 0.091, // Calculate VAT (approximately 10%)
              totalPremium: apiTotalPremium,

              // Store API response data with proper structure for modal
              apiData: {
                ...planData,
                quoteNumber: `TRV-${Date.now()}-${plan.id.toUpperCase()}`, // Generate quote number for display
              },
              hasValidQuote: true,
              apiDataLoaded: true,
            };
          } else {
            console.warn(
              `❌ No pricing data found for plan ${plan.id}:`,
              planData,
            );
            return {
              ...plan,
              hasValidQuote: false,
              apiDataLoaded: false,
            };
          }
        });

        console.log(
          `🎯 Travel plan prices summary: ${successfulPlans}/${currentPlans.length} plans loaded successfully`,
        );
        console.log(
          "🎯 Updated plans:",
          updatedPlans.map((p) => ({
            id: p.id,
            totalPremium: p.totalPremium,
            hasValidQuote: p.hasValidQuote,
            price: p.price,
          })),
        );

        // Only update plans if we have at least one successful plan
        if (successfulPlans > 0) {
          setPlans(updatedPlans);
          console.log("✅ Plans updated successfully");
        } else {
          console.error(
            "❌ No valid plan pricing data found, keeping original plans",
          );
          setLoadingError(true);

          // Keep original plans but mark them as not having quotes
          const fallbackPlans = currentPlans.map((plan) => ({
            ...plan,
            hasValidQuote: false,
            apiDataLoaded: false,
          }));
          setPlans(fallbackPlans);

          // Don't retry automatically - let user use manual retry button instead
          console.log(
            "❌ Plan loading failed - no automatic retry, user can use manual retry button",
          );
        }
      } else {
        console.error("❌ Travel plan prices failed:", apiResult?.error);
        setLoadingError(true);

        // Don't retry automatically - let user use manual retry button instead
        console.log(
          "❌ API failure - no automatic retry, user can use manual retry button",
        );
      }
    } catch (error) {
      console.error("❌ Failed to load travel plan prices:", error);
      setLoadingError(true);

      // Don't retry automatically - let user use manual retry button instead
      console.log(
        "❌ Network error - no automatic retry, user can use manual retry button",
      );
    } finally {
      setRatesLoaded(true);
      console.log("🎯 Travel plan prices loading completed");
    }
  };

  /* Plan selection - SAVE TO REDUX FOR REVIEW PAGE */
  const planOnClickHandler = async (plan) => {
    console.log("selected plan is: ", plan.code);
    console.log("current plan is: ", currentPlan);

    // If user selects the same plan as current, don't allow continuation
    if (plan.code === currentPlan) {
      console.log("User selected current plan - not allowing continuation");
      setSelectedPlan(null);
      return;
    }

    setSelectedPlan(plan);

    // Save to Redux for both travel form and motor form (for Summary component)
    saveTravelDataInRedux(plan);
    saveMotorDataInRedux(plan);
    console.log(
      "Selected plan saved to Redux for review page and summary modal",
    );
  };

  /* Filter Plans - show all new travel plans (Schengen / Worldwide ex / Worldwide) */
  const getVisiblePlans = (currentPlan) => {
    return plans.map((plan) => ({ ...plan, isShown: true }));
  };

  const updatedPlans = getVisiblePlans(currentPlan);

  /* Benefits Modal Handler */
  const handleViewBenefits = () => {
    setShowBenefitsModal(true);
  };

  /* Show Summary Modal Handler */
  const handleShowSummary = () => {
    console.log("=== Show Summary clicked for change plan ===");
    console.log("Selected plan:", selectedPlan);
    console.log("Selected plan has API data:", !!selectedPlan?.apiData);
    console.log("Selected plan total premium:", selectedPlan?.totalPremium);

    // For change plan, we don't need to fetch additional quote data
    // We already have the pricing from the plan prices API
    if (selectedPlan && selectedPlan.hasValidQuote) {
      console.log("✅ Plan data available, showing summary modal");
      setShowSummaryModal(true);
    } else {
      console.log("❌ No valid plan data available");
    }
  };

  /* Handle back button click - navigate to policy overview */
  const handleBackClick = () => {
    console.log("Back button clicked - navigating to policy overview");
    // Navigate back to the policy overview page
    navigate(-1); // Go back to previous page (policy overview)
  };

  /* Manual retry handler */
  const handleManualRetry = () => {
    console.log("🔄 Manual retry triggered");
    setRetryCount(0);
    setLoadingError(false);
    setHasTriggeredInitialLoad(false); // Allow retry
    loadTravelPlanPrices();
  };

  /* Next */
  const continueClickHandler = () => {
    console.log("Continue clicked - proceeding to review and confirm");
    handleNextSubstep();
  };

  // Debug: console.log("RENDER: selectedPlan =", selectedPlan, "btn_disabled =", !selectedPlan);

  return (
    <>
      <SelectNewTravelPlanLayout
        is_hide_back_btn={false}
        show_close_btn={false}
        isFirstStep={false}
        backClickHandler={handleBackClick}
        btn_disabled={!selectedPlan || selectedPlan?.code === currentPlan}
        show_summary={true}
        btn_onClick={continueClickHandler}
        price={selectedPlan?.totalPremium || 0}
        onShowSummary={handleShowSummary}
        onBackClick={handleBackClick}
      >
        <div className="changeyourplan p-4 pt-0 w-[33%] max-350:w-[100%] max767:w-[100%] ipad:w-[55%] mx-auto max767:p-5">
          <TitleDescription
            title={translate("Choose Your Plan", "تحديث سياستك")}
            description={translate(
              "Select the plan that best suits your needs.",
              "حدد الخطة الجديدة التي تناسب احتياجاتك بشكل أفضل.",
            )}
          />
        </div>
        <div className="selectyourcard">
          <div className="max767:w-full max767:overflow-x-scroll max767:pt-0 ipad:overflow-x-hidden ipad:w-[100%] ipad:py-10 mx-auto ipad:pb-8 max767:mb-8  ipad:!mb-8 max767:!mb-8">
            <div className="flex gap-4 mb-4 max767:w-max max767:pl-5 max767:pr-5 max767:py-0 max767:pt-5 ipad:w-[100%] ipad:justify-center ipad:items-center ipad:content-center ipad:my-0 ipad:flex-wrap justify-center">
              {isPolicyViewLoading ? (
                <Loader /> // Show Loader only when loading policy view
              ) : (
                updatedPlans.map(
                  (plan) =>
                    plan.isShown && (
                      <PlanCard
                        key={plan.code}
                        planOnClickHandler={planOnClickHandler}
                        selectedPlan={selectedPlan}
                        plan={plan}
                        isCurrentPlan={plan.code === currentPlan}
                        showSelectButton
                        showPriceLoader={planPricesLoading}
                        cardClassName="!min-h-[372px]"
                      />
                    ),
                )
              )}
            </div>

            {/* Show retry button if loading failed */}
            {loadingError && ratesLoaded && (
              <button
                className="flex items-center mx-auto gap-2 border bg-red-50 border-red-200 text-red-600 px-4 py-2 rounded-[10px] text-sm not-italic font-semibold leading-6 tracking-[-0.084px] mt-4 hover:bg-red-100"
                onClick={handleManualRetry}
              >
                🔄 {translate("Retry Loading Plans", "إعادة تحميل الخطط")}
              </button>
            )}
          </div>
          {/* Only show benefits buttons when plans are loaded */}
          {ratesLoaded && plans.length > 0 && (
            <>
              <button
                className="flex items-center mx-auto gap-2 border bg-white px-4 py-2 rounded-[10px] border-solid border-[#DDE2E4] text-[#1A2024] text-sm not-italic font-semibold leading-6 tracking-[-0.084px] ipad:mt-4 max767:hidden"
                onClick={handleViewBenefits}
              >
                <img src={listblackicon} alt="altText" />
                {translate(
                  "View full list of benefits & covers",
                  "عرض القائمة الكاملة للفوائد والتغطيات",
                )}
              </button>
              <button
                className="flex items-center mx-auto gap-2 border bg-white px-4 py-2 rounded-[10px] border-solid border-[#DDE2E4] text-[#48535B] text-sm not-italic font-semibold leading-6 tracking-[-0.084px] ipad:mt-4 hidden max767:block max767:flex"
                onClick={handleViewBenefits}
              >
                <img src={listblackicon} alt="altText" />
                {translate(
                  "View full list of benefits & covers",
                  "عرض القائمة الكاملة للفوائد والتغطيات",
                )}
              </button>
            </>
          )}
        </div>
      </SelectNewTravelPlanLayout>

      {/* Benefits Modal */}
      <TravelBenefitsModal
        show={showBenefitsModal}
        onClose={() => setShowBenefitsModal(false)}
        plans={updatedPlans}
      />

      {/* Summary Modal */}
      <ViewSummaryPopup
        show={showSummaryModal}
        setShow={setShowSummaryModal}
        passedFrom="TravelChangePlan"
      />
    </>
  );
};

export default SelectNewTravelPlan;
